export default __webpack_public_path__ + "static/media/exclamation-mark.7299157c.svg";